type Partner = {
  attributes?: {
    pos?: string
  }
}

type FeatureVisibility = {
  showPromoCodes: boolean
  showLoyalty: boolean
}

export function getFeatureVisibilityByPOS(partner?: Partner): FeatureVisibility {
  const posName = partner?.attributes?.pos?.toLowerCase() || ''
  
  const isSquarePos = posName === 'square'
  const isToastPos = posName === 'toast'

  return {
    showPromoCodes: !(isSquarePos || isToastPos),
    showLoyalty: !isSquarePos,
  }
}
